var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "full_layout information", attrs: { id: "Information" } },
      [
        _c("h3", { staticClass: "informationTitle" }, [_vm._v("隐私政策")]),
        _vm._v(" "),
        _c("div", { staticClass: "informationBox" }, [
          _c("div", [
            _vm._v(
              "达咖（“我们”）深知用户个人隐私及信息的重要性，一贯重视用户的个人信息及个人隐私的保护，我们将按照法律法规的要求，采取相应的措施保护您个人信息的安全可控。在您使用达咖App以及达咖网（http://daka-culture.com/）的服务和/或在达咖App以及达咖网（http://daka-culture.com/）交易购买商品的时候，达咖有可能会收集和使用您的个人信息及隐私。达咖App和达咖网（http://daka-culture.com/）以下简称“达咖平台”。为此，达咖平台通过本《隐私政策》向您说明您在使用达咖平台的服务和/或在达咖平台交易购买商品时，达咖平台是如何收集、保存、使用和分享这些信息的，以及达咖平台向您提供的访问、更新、控制和保护这些信息的方式。"
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "本《隐私政策》与您使用达咖平台的服务、在达咖平台交易购买商品息息相关，请您务必仔细阅读、充分理解（未成年人应当在其监护人的陪同下阅读）。"
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "在使用达咖平台各项产品或服务前，请您务必仔细阅读本政策，特别是以粗体标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。如对本政策内容有任何疑问、意见或建议，您可通过达咖平台提供的各种联系方式与我们取得联系。"
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "本隐私政策将帮助您了解以下内容：1、个人隐私信息定义及保证；2、我们如何收集和使用您的个人信息；3、我们如何管理及保护您的个人信息；4、 我们如何共享、转让、公开披露您的信息；5、我们如何处理未成年人的信息；6、如何联系我们。"
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "useragreement" }, [
            _c("li", [
              _c("div", { staticClass: "t1" }, [
                _vm._v("一、个人隐私信息的定义及保证")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "1、个人隐私信息：是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。包括但不限于您在注册或使用达咖平台时填写或生成的姓名、住址、联系方式、支付信息、交易信息、面部生物识别信息等单独或与其他信息对照可以识别特定个人的信息。"
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "2、系统权限：是指您在使用达咖平台部分功能时授权达咖平台可调用的系统权限，包括但不限于：系统相册（如照片存储在外置存储设备，则会调用外置存储设备中的照片信息）、摄像头、地理位置、麦克风等，该系统权限的调用将事先获得您的同意，您也可在系统权限中进行关闭。"
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "strong" }, [
                _vm._v(
                  "3、您承诺并保证：您主动填写或者提供给达咖平台的个人信息是真实的、 准确的、完整的。而且，填写或者提供给达咖平台后，如果发生了变更的，您会在第一时间内，通过原有的渠道或者达咖平台提供的新的渠道进行更新，以确保达咖平台所获得的您的这些个人信息是最新的、真实的、准确的和完整的；否则，达咖平台无须承担由此给您造成的任何损失。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("div", { staticClass: "t1" }, [
                _vm._v("二、我们如何收集和使用您的个人信息")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "t3" }, [
                _c("div", { staticClass: "t2" }, [_vm._v("（一）注册及使用")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "如您注册达咖平台账户时，我们将收集您的手机号码作为登录账号，在您登录时核验您的身份，用于交易的诚信参考和保障；收集您的注册昵称及头像用于公开展示，以保证交易辨识度；如您需要上传头像，则上传需要调用相册及/或摄像头权限。"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "您也可在非登录注册状态下使用达咖平台,我们会收集您的IMEI、IMSI、 设备类型、系统版本、IP地址等设备信息。如果您不提供上述信息，可能无法使用达咖的服务。但请注意：单独的设备信息无法识别特定自然人的个人信息。1、需要获取IMEI、IMSI、设备MAC地址信息（应用集成了第三方厂商网易云信的 IM(即时通讯)SDK，确保设备的唯一性，实现稳定的APP私聊，并用于统计用户的活跃数量，总用户数量信息）。2、百度推送SDK，用于消息推送，精准传达给用户。3、软件列表：获取用户安装的软件列表用户，判断用户是否安装了 QQ、微博等软件，用于分享功能模块。4、设备序列号、系统ID：用户版本的判断，用户系统版本的适配及版本升级。5、我们的产品集成友盟+SDK,友盟+SDK需要收集您的设备Mac地址、唯一设备识别码 （IMEI/androidID/IDFA/OPENUDID/IP 地址/GUID、SIM卡 IMSI信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "t3" }, [
                _c("div", { staticClass: "t2" }, [_vm._v("（二）交易")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "当您在达咖平台购买商品时：（1）我们需要收集您的收货姓名、联系方式及收货地址，用于快递发货以及联系您收货；（2）我们需要收集您的支付信息，用于您在购买商品时进行支付以及完成风控验证；（3）当您产生退款或者赔偿业务时，我们需要收集您的支付信息以及真实姓名，用于退款及赔偿的转账；（4）我们需要收集您的操作日志，根据您的使用记录、设备信息、位置信息、收藏信息、订单信息，向您推荐相关商品；（5）我们在您自愿的前提下收集您对商品的评价，给予他人参考。对于卡品、卡信息、诚信、物流、您可以选填，如您不提供前述信息，并不影响您使用我们的评价功能。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "t3" }, [
                _c("div", { staticClass: "t2" }, [_vm._v("（三）服务功能")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "1、当您充值达咖账户金额时，我们将收集您的Apple ID或支付信息或其他第三方支付信息，用于记录用户充值情况。"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "2、我们需要收集您的支付信息，用于您在买卖服务时进行支付以及完成风控验证。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "t3" }, [
                _c("div", { staticClass: "t2" }, [
                  _vm._v("（四）风控、安全管理")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "在您使用我们服务过程中，为识别账号异常状态、了解产品适配性、向您提供更契合您需求的页面展示和搜索结果，我们可能会自动收集您的使用情况并存储为网络日志信息，包括：设备信息：我们会根据您在软件安装及/或使用中的具体操作，接收并记录您所使用的设备硬件信息（包括设备型号、操作系统版本、设备设置、唯一设备标识符、设备环境等软硬件特征信息等）、系统参数、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站等传感器信息）、系统软件列表设备唯一标识码等设备信息。"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "服务日志信息：当您使用达咖平台提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括浏览、点击查看、搜索查询、收藏、交易、售后、关注分享信息、发布信息，以及IP地址、访问日期和时间等行为信息。"
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "strong" }, [
                  _vm._v(
                    "您应了解：单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。"
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "strong" }, [
                  _vm._v(
                    "另外，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：⑴与国家安全、国防安全等国家利益直接相关的；（2）与公共安全、公共卫生、公共知情等重大公共利益直接相关的；（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；（4）出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；（5）所收集的个人信息是您自行向社会公众公开的；（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；（7）根据您要求签订和履行合同所必需的；（8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；（9）法律法规规定的其他情形。"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "如果您选择使用前述说明当中尚未涵盖的其他服务，基于该服务我们需要收集您的信息的，我们会征得您的同意。我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息；"
                  ),
                  _c("span", { staticClass: "strong" }, [
                    _vm._v(
                      "如您选择不提供前述信息，您可能无法使用某项或者某部分服务，但是不影响您使用我们提供的其他服务。"
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("div", { staticClass: "t1" }, [
                _vm._v("三、我们如何管理及保护您的个人信息")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "t3" }, [
                _c("div", { staticClass: "t2" }, [
                  _vm._v("（一）我们如何保护您的个人信息")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "对于收集的信息，我们努力采取符合业界标准、合理可行的安全防护措施保护您的信息，以防止信息的泄露、丢失、不当使用、未经授权访问、修改和披露等。我们采取多方位的安全保护措施，以确保用户的个人信息保护处于合理的安全水平，包括管理制度控制、安全体系保障等诸多方面。我们会部署访问控制机制，尽力确保只有被授权的人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。对于违反义务的人员会根据相关规定进行处罚。"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "我们保证我们收集的信息，都是必要的。我们会尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "我们将在中华人民共和国境内运营所收集或产生的个人信息存储在中华人民共和国境内。我们建议您在使用产品和服务时充分注意对个人信息的保护，我们也会提供多种安全功能来协助您保护自己的个人信息安全。"
                  ),
                  _c("span", { staticClass: "strong" }, [
                    _vm._v(
                      "您应当重视您的个人信息的保护，您如果发现您的个人信息已经被泄露或者存在被泄露的可能，且有可能会危及您注册获得的达咖平台账户安全，或者给您造成其他的损失的，您务必在第一时间通知达咖平台,以便达咖平台采取相应的措施确保您的达咖平台账户安全，防止损失的发生或者进一步扩大；否则，达咖平台无须承担由此给您造成的任何损失（及扩大的损失）。"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "strong" }, [
                  _vm._v(
                    "您充分理解并完全接受：即便是达咖平台釆取各种安全技术和程序存储、保护用户信息，防止其被未经授权的访问、使用、复制和泄露，但用户信息仍然有可能发生被黑客攻击、窃取，因不可抗力或者其他非达咖平台的自身原因而被泄露的情形。对此，只要是达咖平台采取了必要的措施防止上述情形之发生，并在上述情形发生之后采取必要的措施防止其损失进一步扩大，达咖平台则无须赔偿由此给您造成的任何损失及承担任何责任或法律责任。\n          "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "当我们的服务发生停止运营的情形时，我们会将停止运营的情况以公告的形式向您发送推送。并及时将收集的您的个人信息进行删除。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "t3" }, [
                _c("div", { staticClass: "t2" }, [
                  _vm._v("（二）我们如何管理您的个人信息")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "为了您可以更加便捷地访问和管理您的信息，您可以通过以下方式进行操作："
                  )
                ]),
                _vm._v(" "),
                _c("dl", [
                  _c("dt", [_vm._v("1、查询、更正、补充您的个人信息")]),
                  _vm._v(" "),
                  _c("dd", [
                    _vm._v(
                      " ⑴账户信息：如果您希望查询并管理您账户中的个人基本资料信息，您可以通过“我的”，然后点击个人信息区域，然后点击头像来更改头像，并且可以修改昵称、登录密码和收货地址。（2）订单信息：您可以点击“我的”，可以在“全部订单”里面查看您作为买家购买的商品的订单。（3）地址管理：如果您希望管理您的收货地址，您可以点击“我的”，然后点击个人信息区域，点击收货地址管理，来管理您的地址。（4）消息通知：如果您希望管理消息通知的方式，您可以点击“我的”，然后点击“设置”图标，点击“推送通知”，来更改通知的方式。（5）付款账户：如果您希望管理您的付款账户，您可以点击“我的”，然后点击“支付管理”图标，来管理您的付款账户。您可以通过您的手机系统设置来管理、开通或关闭系统权限, 包括但不限于相册、摄像头、麦克风、地理位置等系统权限。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("dt", [_vm._v("2、删除您的个人信息")]),
                  _vm._v(" "),
                  _c("dd", [
                    _vm._v(
                      "您可以通过前款“查询、更正和补充您的个人信息”中列明的方式删除您的部分信息。在以下情形中，您可以向我们提出删除个人信息的清求： （1）如果我们处理个人信息的行为违反法律法规；（2）如果我们收集、使用您的个人信息，却未征得您的明确同意；（3）如果我们处理个人信息的行为严重违反了与您的约定；（4）如果我们永久不再为您提供产品或服务。若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除您的个人信息（除非法律法规另有规定或这些主体已独立获得您的授权）。"
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("div", { staticClass: "t1" }, [
                _vm._v("四、我们如何共享、转让、公开披露您的信息")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "t3" }, [
                _c("div", { staticClass: "t2" }, [_vm._v("（一）共享")]),
                _vm._v(" "),
                _c("p", { staticClass: "strong" }, [
                  _vm._v(
                    "我们不会向达咖平台服务提供商之外的其他第三方共享您的信息，但您应知悉以下情况除外："
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "（1）我们可能会根据法律法规规定、诉讼、争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。（2）您通过达咖平台交易买卖或使用达咖平台服务时，我们会将您的交易订单或服务中所涉及交易或服务的必要信息共享给您的交易或服务相对方，便于对方为您提供商品或服务。包括但不限于：快递物流服务提供商（为派送服务所必须的订单信息、收货人姓名、联系方式、地址信息）、私信服务提供商（为使用私信所必须的账号信息）、金融服务提供商（为申请授信和使用授信所必须的姓名、身份证号码、银行卡号码、第三方支付账号及预留手机号码、订单信息等）。（3）为便于达咖平台向您提供更优质的服务、识别用户账号的安全性、保护达咖平台或其他第三方的利益不受侵害，您的个人信息可能会与我们的服务提供商共享。但我们将会对信息进行去标识化处理或要求我们的服务商提供更为严格的数据保护措施。包括：我们将在使用第三方提供的算法推荐服务的情况下向第三方共享行为日志信息，所涉信息均做脱敏处理等；我们在进行内容安全审核时会向第三方内容安全服务提供商同步您所发布的内容信息及必要的个人信息（头像、昵称等）以判断内容是否合法合规，但我们会要求第三方设立严格的数据保护措施；我们在对您的操作进行账户、交易等风险识别时，可能会将您的设备信息及个人信息（手机号码）同步给第三方安全服务提供商以判断您的操作风险，但我们会要求第三方设立严格的数据保护措施。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "t3" }, [
                _c("div", { staticClass: "t2" }, [_vm._v("（二）转让")]),
                _vm._v(" "),
                _c("p", { staticClass: "strong" }, [
                  _vm._v(
                    "除非达咖平台运营主体发生变更，否则达咖平台不会向任何第三方转让您的个人信息。如达咖平台运营主体变更导致转让您的个人信息，我们也会严格要求受让主体按照本隐私政策严格保护您的个人信息。否则，我们将要求该受让主体重新向您征求授权同意。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "t3" }, [
                _c("div", { staticClass: "t2" }, [_vm._v("（三）公开披露")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "1、我们不会主动地将您的信息向第三方进行披露，但是在以下情形中，我们可能会披露您的个人信息无需事先征得您的授权同意：（1）与国家安全、国防安全直接相关的；（2）与公共安全、公共卫生、重大公共利益直接相关的；（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；（5）个人信息主体自行向社会公众公开个人信息的；（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "2、根据相关法律规定，当您被投诉时，我们可能会根据有关行政监管部门的要求，向有关行政监管部门披露您的有关信息，便于投诉纠纷得到有效的解决。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "t3" }, [
                _c("div", { staticClass: "t2" }, [
                  _vm._v("五、我们如何处理儿童个人信息")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "strong" }, [
                  _vm._v(
                    "我们非常重视儿童的个人信息保护。在电商活动中，我们推定您具有相应的民事行为能力。如您为未成年人，请您确保您的父母或监护人已仔细阅读本隐私政策，并就您使用达咖平台获得您的父母或监护人的同意。"
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "strong" }, [
                  _vm._v(
                    "我们不收集任何14周岁以下的儿童个人信息，如果我们识别出您是儿童，我们将通过联系您的监护人确认您使用达咖平台是否获得监护人的同意。如发现在未事先获得可证实的父母或其他监护人同意的情况下收集到儿童个人信息，我们会立刻删除相关信息。"
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "strong" }, [
                  _vm._v(
                    "如果您的监护人不同意您按照本政策使用我们的服务或者向我们提供信息，请您立即停止向我们提供信息并及时通知我们，以便于我们将您已经提供的信息进行删除。"
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "strong" }, [
                  _vm._v(
                    "如您作为监护人，请您关注您监护的儿童是否在未取得您的同意的前提下使用达咖平台服务。"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("div", { staticClass: "t1" }, [_vm._v("六、如何联系我们")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "1、如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，请通过访问在线客服系统或拨打我们的客服电话【 4008215220 】 等多种方式与我们联系，我们会对您提出的问题、意见或建议及时回复或处理。"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "time" }, [
            _c("div", [_vm._v("更新日期：2023年04月10日")]),
            _vm._v(" "),
            _c("div", [_vm._v("本隐私政策生效日期：2023年04月10日")]),
            _vm._v(" "),
            _c("div", [_vm._v("上海达咖文化发展有限公司")])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39a0fe09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39a0fe09","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/information/privacyagreement.vue
// module id = null
// module chunks = 